module.exports = __webpack_public_path__ + "english-flag.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english-flag.svg
// module id = 853
// module chunks = 0